const forgotPassword = {
  en: {
    title: "Forgot your password?",
    description:
      "Enter your email address to confirm your identity and receive a link to create a new password",
    placeholder: "Enter your email",
    successTitle: "Email sent",
    successText:
      "If the email address you entered is registered in the system, you will receive a message. Check your inbox to create a new password."
  },
  pt: {
    title: "Esqueceu sua senha?",
    description:
      "Digite seu email para confirmar sua identidade e receber um link para criar uma nova senha",
    placeholder: "Insira seu email",
    successTitle: "Email enviado",
    successText:
      "Se o email informado estiver cadastrado no sistema, você receberá uma mensagem. Verifique sua caixa de entrada para criar uma nova senha."
  },
  es: {
    title: "Ha olvidado su contraseña?",
    description:
      "Introduzca su correo electrónico para confirmar su identidad y recibir un enlace para crear una nueva contraseña",
    placeholder: "Introduzca su correo electrónico",
    successTitle: "Correo electrónico enviado",
    successText:
      "Si el correo electrónico que ha introducido está registrado en el sistema, recibirá un mensaje. Comprueba tu bandeja de entrada para crear una nueva contraseña."
  }
}

export default forgotPassword
